import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { CalculationResult, ToolOutput } from '../../../models/calculationModels';
import { PlantmanagerService } from 'src/app/Modules/idms/components/plant-manager/services/plantmanager.service';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
@Component({
    selector: 'app-select-tool',
    templateUrl: './select-tool.component.html',
    styleUrl: './select-tool.component.scss',
    standalone: false
})
export class SelectToolComponent {
    @Input() calcOutput: CalculationResult;
    @Input() selectedTool: ToolOutput;
    isSubscribe: Subject<any> = new Subject<any>();
    noTool: boolean = false;
    constructor(
        private plantManagerservice: PlantmanagerService,
        private globalEmittersService: GlobalEmittersService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes?.selectedTool?.currentValue) {
            this.globalEmittersService.isToolSelected.next(false);
        }

        if (!changes?.calcOutput?.currentValue?.output?.tools?.length) {
            this.noTool = true;
        } else {
            this.noTool = false;
        }
    }

    ngOnInit(): void {
        let tt = this.selectedTool;
        this.globalEmittersService.isToolSelected.next(this.selectedTool?.name ? true : false);

        this.globalEmittersService.isIdmsPreferenceSettingUpdated.pipe(takeUntil(this.isSubscribe)).subscribe((res) => {
            if (res) {
                this.selectedTool = null;
            }
        });
    }
    selectTool(type: any) {
        this.plantManagerservice.loadToolSelection.next(type);
        this.globalEmittersService.isToolSelected.next(true);
    }
}
